import { render } from "./BatchesWaitingToReceiveFullscreenModal.vue?vue&type=template&id=7c7aad7e"
import script from "./BatchesWaitingToReceiveFullscreenModal.vue?vue&type=script&lang=js"
export * from "./BatchesWaitingToReceiveFullscreenModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__